import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

interface Props {
  onValid: () => void;
}

function ModalReCaptcha({ onValid }: Props) {
  function onChange(value: any) {
    if (value != null) {
      onValid();
    }
  }

  return (
    <div className="modalBackground">
      <div className="modalContainer">
        <ReCAPTCHA sitekey={process.env.REACT_APP_SITE_KEY!} onChange={onChange} />
      </div>
    </div>
  );
}

export default ModalReCaptcha;
